import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';
import { ConfirmDialogData } from '@klubovna/shared-models';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private dialog = inject(MatDialog);
  private translate = inject(TranslateService);

  confirmDialog(data: ConfirmDialogData): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data,
      disableClose: true,
      panelClass: 'custom-dialog-panel',
      backdropClass: 'custom-dialog-backdrop',
    });

    return dialogRef.afterClosed();
  }

  deleteConfirm(itemType: string, itemName: string): Observable<boolean> {
    const data: ConfirmDialogData = {
      title: this.translate.instant('admin.dialogs.delete_confirm_title'),
      message: this.translate.instant('admin.dialogs.delete_confirm_message', {
        type: itemType,
        name: itemName,
      }),
      confirmText: this.translate.instant('admin.common.delete'),
      cancelText: this.translate.instant('admin.common.cancel'),
      type: 'danger',
      icon: 'delete_forever',
    };

    return this.confirmDialog(data);
  }

  warningConfirm(title: string, message: string): Observable<boolean> {
    const data: ConfirmDialogData = {
      title,
      message,
      type: 'warning',
      icon: 'warning',
    };

    return this.confirmDialog(data);
  }

  infoConfirm(title: string, message: string): Observable<boolean> {
    const data: ConfirmDialogData = {
      title,
      message,
      type: 'info',
      icon: 'info',
    };

    return this.confirmDialog(data);
  }
}
